/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { push } from 'connected-react-router';
import { Icon } from '@mui';
import IconMenu from '@shared/icon-menu';
import IconMenuItem from '@shared/icon-menu-item';
import DrawLineIcon from '@icons/draw-line-icon';
import { canEditGroups } from '@utils/permission-utils';
import { openDashboardDialog } from '@actions/dashboard-actions';
import { setGroupPreFill } from '@actions/groups-actions';
import * as dialog from '@constants/dialogs';
import GroupsAddRecordsDialog from '@components/group/dialogs/add-records';

const TopBarActionGroupAdd = () => {
  const dispatch = useDispatch();

  const { data } = useSelector(state => state.dataDetail);
  const { groupType, id } = useParams();

  const goToMapSelection = () => {
    dispatch(setGroupPreFill({ id, groupType }));
    dispatch(push(
      {
        pathname: '/map',
        state: {
          source: `/group/${groupType}/${id}`
        }
      }
    ));
  };

  const openSearch = () => {
    const params = {
      group: data,
      groupTypeName: groupType
    };
    dispatch(openDashboardDialog(dialog.ADD_RECORDS_TO_GROUP, params));
  };

  const area_capture = 1;
  return (
    <div>
      {id && canEditGroups(groupType) &&
        <IconMenu
          icon={<Icon>add</Icon>}
          iconButtonStyles={{}}
          MenuProps={{
            anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
            transformOrigin: { horizontal: 'center', vertical: 'top' }
          }}
          tooltip="Add records"
        >
          {area_capture === 0 && (
            <IconMenuItem icon={<DrawLineIcon />} onClick={goToMapSelection}>
              Add records by map selection
            </IconMenuItem>
          )}
          <IconMenuItem icon={<Icon>search</Icon>} onClick={openSearch}>
            Add records by searching
          </IconMenuItem>
        </IconMenu>
      }
      <GroupsAddRecordsDialog />
    </div>
  );
};

export default TopBarActionGroupAdd;
